import PageNavbar from '../../components/feature/PageNavbar';
import PageCloudHero from '../../components/feature/PageCloudHero';
import { useTranslation } from 'react-i18next';
import CTA from '../home/components/CTA';
import Footer from '../home/components/Footer';
import ContactInfoBento from './components/ContactInfoBento';

export default function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#0D0D0D] text-white">
      <PageNavbar />

      <PageCloudHero
        badge={t('contact.hero.badge')}
        badgeIcon="ri-chat-1-line"
        title={t('contact.hero.title')}
        lead={t('contact.hero.lead')}
        supporting={t('contact.hero.supporting')}
      />

      <ContactInfoBento />

      <CTA />
      <Footer />
    </div>
  );
}
